<p-confirmDialog #cd key="{{ key }}" appendTo="body" header="{{ header | hisUi }}">
    <p-footer>
        <button (click)="cd.accept()"><span>{{'de.his.javang.ja'| hisUi}}</span></button>
        <button (click)="cd.reject()"><span>{{'de.his.javang.nein'| hisUi}}</span></button>
    </p-footer>
</p-confirmDialog>
